import React from "react";
import { PrimaryButton } from "../Cta";

export default function ImageModal({ img, close, width, containerWidth }) {
  return (
    <div className=" position-fixed top-0 start-0 e-bg-modal min-h-100vh min-vw-100 d-flex align-items-center justify-content-center">
      <div className="row w-100 d-flex align-items-center justify-content-center">
        <div className="e-w-fit" style={{width:containerWidth}}>
          <div className="bg-white e-border-radius-24 e-p-32px">
            <div className="d-flex justify-content-between align-items-center pb-2">
              <h5 className=" text-start e-font-weight-600 e-font-20 line-height-32px e-primary-font-poppins">
                View document
              </h5>
              <PrimaryButton
                icon="close-button"
                name=""
                size='16px'
                ClassName="bg-white pt-0"
                onPress={close}
              />
            </div>

            <div className="d-flex e-border-radius-16 p-4 w-100 e-border-1px-pale-lavender e-bg-magnolia-medium justify-content-center">
              <img
                src={img}
                width={width}
                className=" object-fit-fill"
                alt="doc"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
